export enum RewardValidationTracking {
    TotalOdds = 'bet does not meet the criteria: total odds',
    SelectionLevelMinimumOdds = 'bet does not meet the criteria: min. odds',
    MinimumLegs = 'bet does not meet the criteria: min. legs',
    MinimumStake = 'bet does not meet the criteria: min. stake',
    MaximumStake = 'bet does not meet the criteria: max. stake',
    SlipType = 'bet does not meet the criteria: {{criteria}}',
}
